<template>
  <div class="relative flex min-h-screen flex-col">
    <main class="flex flex-1 flex-col">
      <slot />
    </main>
    <UiSnackBanner />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
